import * as z from 'zod';

import { EscrowPaymentHistoryItemId, PaymentConfigId, PrincipalModificationId } from '../BrandedIds';
import { zodJSInstantDate, zodJSPlainDate } from '../dates/BrandedDate';
import { zodBrandedUuid } from '../utils';

export const PaymentConfigSource = z.enum([
  'initial',
  'escrowMonthlyInsuranceManualUpdate',
  'updateBuydownInterestRate',
  'armUpdate',
  'armManualUpdate',
  'constructionToPermanentEvent',
  'updateDelinquentInterestRate', // Deprecating this
  'manualUpdate',
  'drawRecord',
  'flexModification',
]);

export type PaymentConfigSource = z.infer<typeof PaymentConfigSource>;

export const PaymentConfig = z.object({
  id: zodBrandedUuid<PaymentConfigId>(),
  source: PaymentConfigSource,
  referenceId: zodBrandedUuid<EscrowPaymentHistoryItemId>().optional(),
  createdAt: zodJSInstantDate,
  effectiveDate: zodJSPlainDate,
  type: z.enum(['fixed', 'arm']),
  isInterestOnly: z.boolean(),
  /**
   * @deprecated
   * Use getCurrentPrincipalAndInterest as this config item does not contain a full history for loans w/ draws or other interest-changing events
   */
  monthlyPrincipalAndInterestTotal: z.number(), // This should just be called principalAndInterestTotal
  // TODO: Buydown interest rate should live on a new field in payment config history. not monthly interest rate.
  monthlyInterestRate: z.number(), // This should just be called interestRate
  modificationId: zodBrandedUuid<PrincipalModificationId>().optional(),
});
export type PaymentConfig = z.infer<typeof PaymentConfig>;
